module.exports = __webpack_public_path__ + "static/media/supporting_2.0d414aa5.png";